var _defs, _sodipodiNamedview;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBwAbrev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 492.63956,
    height: 94.69104,
    viewBox: "0 0 492.63955 94.691039",
    sodipodiDocname: "Vectores Regi\\xF5es e N\\xFAcleos CNE 2023.pdf",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath297"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-70.870202,-119.7496)",
    id: "path297"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath299"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-99.687805,-120.1337)",
    id: "path299"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath301"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-58.167301,-98.3156)",
    id: "path301"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-83.5,-98.3156)",
    id: "path303"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath305"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-74.587802,-85.335402)",
    id: "path305"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath307"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-121.53711,-95.102502)",
    id: "path307"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath309"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-134.8101,-85.541202)",
    id: "path309"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-149.3203,-89.659902)",
    id: "path311"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath313"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-161.4312,-89.4833)",
    id: "path313"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath315"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-174.2187,-85.541202)",
    id: "path315"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath317"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-190.92291,-94.837602)",
    id: "path317"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath319"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-210.83061,-88.159602)",
    id: "path319"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath321"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-222.4561,-95.102502)",
    id: "path321"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath323"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-231.24321,-94.6757)",
    id: "path323"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath325"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-242.86671,-85.541202)",
    id: "path325"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath327"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-253.36081,-94.837602)",
    id: "path327"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath329"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-273.2686,-88.159602)",
    id: "path329"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath331"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-280.3936,-94.6757)",
    id: "path331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-300.09571,-85.673502)",
    id: "path333"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath335"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-310.70751,-94.6757)",
    id: "path335"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath337"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-328.57181,-94.6757)",
    id: "path337"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath339"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-339.56451,-86.2031)",
    id: "path339"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath341"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-355.57321,-95.102502)",
    id: "path341"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath343"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-364.22751,-94.6757)",
    id: "path343"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath345"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-379.29541,-93.969702)",
    id: "path345"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath347"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-392.83201,-88.159602)",
    id: "path347"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath349"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-399.29491,-86.2031)",
    id: "path349"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath351"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-124.07961,-111.3452)",
    id: "path351"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath353"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-136.5088,-117.506)",
    id: "path353"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath355"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-160.60011,-118.12231)",
    id: "path355"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-173.6445,-117.506)",
    id: "path357"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath359"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-192.3672,-107.8027)",
    id: "path359"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath361"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-210.9136,-105.8224)",
    id: "path361"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath363"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-240.70071,-105.7783)",
    id: "path363"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath365"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-255.72511,-117.506)",
    id: "path365"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath367"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-289.10011,-118.14421)",
    id: "path367"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath369"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-308.19631,-105.8224)",
    id: "path369"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath371"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-323.17681,-117.506)",
    id: "path371"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath373"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-336.35501,-117.7922)",
    id: "path373"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath375"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-363.98731,-105.66841)",
    id: "path375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath377"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-383.12701,-111.3452)",
    id: "path377"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath379"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-402.61911,-107.8027)",
    id: "path379"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer-MC0",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "Camada 1",
    transform: "translate(-51.843339,-595.70575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g384",
    "inkscapeExport-filename": "../JRC/logo_bw_abrev.svg",
    "inkscapeExport-xdpi": 600.35999,
    "inkscapeExport-ydpi": 600.35999
  }, /*#__PURE__*/React.createElement("path", {
    id: "path296",
    d: "m 0,0 v 0 c -1.554,0 -2.814,-1.26 -2.814,-2.814 v -7.801 h -9.252 c -1.554,0 -2.814,-1.26 -2.814,-2.815 0,-1.554 1.26,-2.814 2.814,-2.814 h 9.252 V -28.76 c 0,-1.554 1.26,-2.814 2.814,-2.814 v 0 c 1.554,0 2.814,1.26 2.814,2.814 v 12.516 h 9.252 c 1.554,0 2.814,1.26 2.814,2.814 0,1.555 -1.26,2.815 -2.814,2.815 H 2.814 v 7.801 C 2.814,-1.26 1.554,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,94.4936,634.0352)",
    clipPath: "url(#clipPath297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path298",
    d: "m 0,0 c -3.587,3.912 -9.224,4.849 -13.784,2.678 0.405,2.877 0.204,5.714 -0.621,8.489 -2.406,8.093 -9.427,14.1 -13.042,16.362 -0.563,0.352 -1.04,0.629 -1.407,0.834 -0.368,-0.205 -0.844,-0.482 -1.407,-0.834 C -33.877,25.267 -40.898,19.26 -43.303,11.167 -44.129,8.392 -44.33,5.555 -43.924,2.678 -48.484,4.849 -54.121,3.912 -57.708,0 c -2.45,-2.671 -3.433,-6.175 -2.997,-9.516 l 4.968,-0.678 c -0.771,2.358 -0.288,5.053 1.504,7.007 1.397,1.523 3.31,2.296 5.23,2.296 1.713,0 3.431,-0.615 4.79,-1.862 0,0 1.258,-1.058 2.177,-2.009 0.502,-0.518 1.485,-1.624 1.76,-2.031 l 3.925,2.313 c -0.331,0.56 -0.631,1.118 -0.909,1.673 -2.191,4.386 -2.709,8.62 -1.531,12.607 1.731,5.855 6.718,10.435 9.937,12.64 3.218,-2.205 8.206,-6.785 9.937,-12.64 1.178,-3.987 0.659,-8.221 -1.532,-12.607 -0.277,-0.555 -0.577,-1.113 -0.909,-1.673 l 3.926,-2.313 c 0.275,0.407 1.258,1.513 1.759,2.031 0.92,0.951 2.178,2.009 2.178,2.009 1.359,1.247 3.077,1.862 4.79,1.862 1.92,0 3.833,-0.773 5.23,-2.296 1.792,-1.954 2.275,-4.649 1.504,-7.007 l 4.968,0.678 C 3.433,-6.175 2.449,-2.671 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,132.91707,633.52307)",
    clipPath: "url(#clipPath299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path300",
    d: "m 0,0 v -2.151 c 0,-3.431 -2.783,-6.224 -6.211,-6.242 v -4.716 c 6.028,0.018 10.926,4.927 10.926,10.958 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,77.5564,662.61387)",
    clipPath: "url(#clipPath301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path302",
    d: "m 0,0 v -2.151 c 0,-3.431 2.783,-6.224 6.211,-6.242 v -4.716 C 0.183,-13.091 -4.715,-8.182 -4.715,-2.151 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,111.33333,662.61387)",
    clipPath: "url(#clipPath303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path304",
    d: "m 0,0 c -1.035,-1.175 -2.308,-2.136 -3.742,-2.807 -1.446,0.676 -2.727,1.647 -3.766,2.835 l -3.616,-3.022 c 0.213,-0.248 0.434,-0.489 0.662,-0.723 1.843,-1.89 4.142,-3.332 6.72,-4.14 2.578,0.808 4.877,2.25 6.72,4.14 0.219,0.225 0.432,0.457 0.638,0.695 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,99.4504,679.9208)",
    clipPath: "url(#clipPath305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path306",
    d: "M 0,0 C 1.485,0 2.559,-0.515 3.56,-1.368 3.677,-1.486 3.692,-1.662 3.574,-1.78 L 3.177,-2.177 C 3.06,-2.324 2.941,-2.31 2.794,-2.162 2.03,-1.5 0.985,-1.059 -0.015,-1.059 c -2.324,0 -4.104,-1.957 -4.104,-4.236 0,-2.266 1.78,-4.222 4.104,-4.222 1.28,0 2.03,0.515 2.809,1.103 0.147,0.118 0.266,0.103 0.353,0.044 l 0.442,-0.397 c 0.118,-0.088 0.088,-0.294 -0.015,-0.397 -1,-0.971 -2.265,-1.427 -3.574,-1.427 -2.942,0 -5.311,2.339 -5.311,5.281 C -5.311,-2.368 -2.942,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,162.04947,666.898)",
    clipPath: "url(#clipPath307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path308",
    d: "M 0,0 C 2.339,0 4.266,1.912 4.266,4.251 4.266,6.59 2.339,8.531 0,8.531 -2.339,8.531 -4.251,6.59 -4.251,4.251 -4.251,1.912 -2.339,0 0,0 m 0,9.561 c 2.942,0 5.295,-2.368 5.295,-5.31 C 5.295,1.309 2.942,-1.03 0,-1.03 c -2.942,0 -5.281,2.339 -5.281,5.281 0,2.942 2.339,5.31 5.281,5.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,179.7468,679.6464)",
    clipPath: "url(#clipPath309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path310",
    d: "M 0,0 C 1.133,0 2.118,0.941 2.118,2.148 2.118,3.265 1.133,4.222 0,4.222 H -2.854 V 0 Z m -4.016,5.016 c 0,0.147 0.118,0.279 0.28,0.279 h 3.809 c 1.766,0 3.207,-1.382 3.207,-3.133 0,-1.353 -0.897,-2.485 -2.177,-3 l 2.015,-3.737 c 0.103,-0.191 0,-0.426 -0.25,-0.426 h -0.75 c -0.132,0 -0.206,0.073 -0.235,0.132 l -1.957,3.898 h -2.809 v -3.751 c 0,-0.147 -0.133,-0.279 -0.28,-0.279 h -0.573 c -0.162,0 -0.28,0.132 -0.28,0.279 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,199.09373,674.1548)",
    clipPath: "url(#clipPath311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path312",
    d: "M 0,0 C 1.206,0 2.236,0.986 2.236,2.25 2.236,3.442 1.206,4.354 0,4.354 H -2.339 V 0 Z m -3.457,5.192 c 0,0.148 0.118,0.28 0.28,0.28 h 3.251 c 1.809,0 3.295,-1.471 3.295,-3.251 0,-1.824 -1.486,-3.309 -3.281,-3.309 h -2.427 v -3.457 c 0,-0.147 -0.132,-0.28 -0.279,-0.28 h -0.559 c -0.162,0 -0.28,0.133 -0.28,0.28 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,215.2416,674.39027)",
    clipPath: "url(#clipPath313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path314",
    d: "M 0,0 C 2.339,0 4.266,1.912 4.266,4.251 4.266,6.59 2.339,8.531 0,8.531 -2.339,8.531 -4.251,6.59 -4.251,4.251 -4.251,1.912 -2.339,0 0,0 m 0,9.561 c 2.942,0 5.295,-2.368 5.295,-5.31 C 5.295,1.309 2.942,-1.03 0,-1.03 c -2.942,0 -5.281,2.339 -5.281,5.281 0,2.942 2.339,5.31 5.281,5.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,232.2916,679.6464)",
    clipPath: "url(#clipPath315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path316",
    d: "m 0,0 c 0,0.147 0.132,0.265 0.279,0.265 h 0.368 l 6.634,-8.267 h 0.03 v 7.84 c 0,0.147 0.117,0.28 0.279,0.28 h 0.515 c 0.147,0 0.279,-0.133 0.279,-0.28 v -9.899 c 0,-0.147 -0.132,-0.265 -0.279,-0.265 H 7.84 L 1.088,-1.897 H 1.074 v -8.002 c 0,-0.148 -0.118,-0.28 -0.28,-0.28 H 0.279 C 0.132,-10.179 0,-10.047 0,-9.899 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,254.56387,667.2512)",
    clipPath: "url(#clipPath317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path318",
    d: "M 0,0 C -0.721,1.603 -1.427,3.221 -2.147,4.825 H -2.265 L -4.413,0 Z m -6.987,-3.119 4.472,9.9 c 0.044,0.088 0.118,0.162 0.25,0.162 h 0.147 c 0.132,0 0.206,-0.074 0.25,-0.162 l 4.442,-9.9 C 2.663,-3.31 2.545,-3.501 2.324,-3.501 H 1.736 c -0.132,0 -0.221,0.088 -0.25,0.162 l -1.089,2.427 h -5.222 l -1.073,-2.427 c -0.03,-0.074 -0.118,-0.162 -0.25,-0.162 h -0.589 c -0.221,0 -0.338,0.191 -0.25,0.382",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,281.10747,676.1552)",
    clipPath: "url(#clipPath319)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path320",
    d: "M 0,0 C 1.486,0 2.56,-0.515 3.56,-1.368 3.678,-1.486 3.692,-1.662 3.575,-1.78 L 3.178,-2.177 C 3.06,-2.324 2.942,-2.31 2.795,-2.162 2.03,-1.5 0.986,-1.059 -0.015,-1.059 c -2.323,0 -4.103,-1.957 -4.103,-4.236 0,-2.266 1.78,-4.222 4.103,-4.222 1.28,0 2.031,0.515 2.81,1.103 0.147,0.118 0.265,0.103 0.353,0.044 L 3.589,-8.767 C 3.707,-8.855 3.678,-9.061 3.575,-9.164 2.574,-10.135 1.31,-10.591 0,-10.591 c -2.941,0 -5.31,2.339 -5.31,5.281 C -5.31,-2.368 -2.941,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,296.60813,666.898)",
    clipPath: "url(#clipPath321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path322",
    d: "M 0,0 C 0,0.147 0.132,0.28 0.279,0.28 H 0.868 C 1.015,0.28 1.147,0.147 1.147,0 v -9.738 c 0,-0.147 -0.132,-0.279 -0.279,-0.279 H 0.279 C 0.132,-10.017 0,-9.885 0,-9.738 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,308.32427,667.46707)",
    clipPath: "url(#clipPath323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path324",
    d: "M 0,0 C 2.339,0 4.266,1.912 4.266,4.251 4.266,6.59 2.339,8.531 0,8.531 -2.339,8.531 -4.251,6.59 -4.251,4.251 -4.251,1.912 -2.339,0 0,0 m 0,9.561 c 2.942,0 5.295,-2.368 5.295,-5.31 C 5.295,1.309 2.942,-1.03 0,-1.03 c -2.942,0 -5.281,2.339 -5.281,5.281 0,2.942 2.339,5.31 5.281,5.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,323.82227,679.6464)",
    clipPath: "url(#clipPath325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path326",
    d: "m 0,0 c 0,0.147 0.132,0.265 0.279,0.265 h 0.368 l 6.634,-8.267 h 0.03 v 7.84 c 0,0.147 0.117,0.28 0.279,0.28 h 0.515 c 0.147,0 0.279,-0.133 0.279,-0.28 v -9.899 c 0,-0.147 -0.132,-0.265 -0.279,-0.265 H 7.84 L 1.088,-1.897 H 1.074 v -8.002 c 0,-0.148 -0.118,-0.28 -0.28,-0.28 H 0.279 C 0.132,-10.179 0,-10.047 0,-9.899 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,337.8144,667.2512)",
    clipPath: "url(#clipPath327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path328",
    d: "M 0,0 C -0.721,1.603 -1.427,3.221 -2.147,4.825 H -2.265 L -4.413,0 Z m -6.987,-3.119 4.472,9.9 c 0.044,0.088 0.118,0.162 0.25,0.162 h 0.147 c 0.132,0 0.206,-0.074 0.25,-0.162 l 4.442,-9.9 C 2.663,-3.31 2.545,-3.501 2.324,-3.501 H 1.736 c -0.132,0 -0.221,0.088 -0.25,0.162 l -1.089,2.427 h -5.222 l -1.073,-2.427 c -0.03,-0.074 -0.118,-0.162 -0.25,-0.162 h -0.589 c -0.221,0 -0.338,0.191 -0.25,0.382",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,364.35813,676.1552)",
    clipPath: "url(#clipPath329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path330",
    d: "M 0,0 C 0,0.147 0.118,0.28 0.279,0.28 H 0.853 C 1,0.28 1.132,0.147 1.132,0 v -9.031 h 4.237 c 0.162,0 0.279,-0.133 0.279,-0.28 v -0.427 c 0,-0.147 -0.117,-0.279 -0.279,-0.279 H 0.279 C 0.118,-10.017 0,-9.885 0,-9.738 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,373.85813,667.46707)",
    clipPath: "url(#clipPath331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path332",
    d: "M 0,0 C 2.412,0 4.163,1.721 4.163,4.148 4.163,6.561 2.412,8.281 0,8.281 H -2.207 V 0 Z m -3.324,9.002 c 0,0.147 0.117,0.28 0.264,0.28 h 3.295 c 2.839,0 5.163,-2.31 5.163,-5.134 0,-2.854 -2.324,-5.163 -5.163,-5.163 H -3.06 c -0.147,0 -0.264,0.132 -0.264,0.28 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,400.1276,679.47)",
    clipPath: "url(#clipPath333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path334",
    d: "M 0,0 C 0,0.147 0.118,0.28 0.279,0.28 H 6.075 C 6.237,0.28 6.354,0.147 6.354,0 v -0.427 c 0,-0.147 -0.117,-0.279 -0.279,-0.279 H 1.132 v -3.589 h 4.222 c 0.147,0 0.28,-0.132 0.28,-0.28 v -0.426 c 0,-0.162 -0.133,-0.28 -0.28,-0.28 H 1.132 v -3.75 h 4.943 c 0.162,0 0.279,-0.133 0.279,-0.28 v -0.427 c 0,-0.147 -0.117,-0.279 -0.279,-0.279 H 0.279 C 0.118,-10.017 0,-9.885 0,-9.738 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,414.27667,667.46707)",
    clipPath: "url(#clipPath335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path336",
    d: "M 0,0 C 0,0.147 0.118,0.28 0.279,0.28 H 6.075 C 6.237,0.28 6.354,0.147 6.354,0 v -0.427 c 0,-0.147 -0.117,-0.279 -0.279,-0.279 H 1.132 v -3.589 h 4.222 c 0.147,0 0.28,-0.132 0.28,-0.28 v -0.426 c 0,-0.162 -0.133,-0.28 -0.28,-0.28 H 1.132 v -3.75 h 4.943 c 0.162,0 0.279,-0.133 0.279,-0.28 v -0.427 c 0,-0.147 -0.117,-0.279 -0.279,-0.279 H 0.279 C 0.118,-10.017 0,-9.885 0,-9.738 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,438.09573,667.46707)",
    clipPath: "url(#clipPath337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path338",
    d: "m 0,0 c 0.074,0.088 0.147,0.191 0.221,0.28 0.147,0.191 0.309,0.308 0.514,0.132 0.103,-0.088 1.177,-1.118 2.487,-1.118 1.191,0 1.97,0.75 1.97,1.618 C 5.192,1.927 4.31,2.53 2.618,3.236 1,3.942 0.029,4.604 0.029,6.281 c 0,1 0.795,2.618 3.134,2.618 1.441,0 2.515,-0.75 2.515,-0.75 C 5.766,8.105 5.943,7.928 5.766,7.649 5.708,7.561 5.648,7.458 5.59,7.37 5.457,7.164 5.31,7.105 5.075,7.237 4.972,7.296 4.045,7.914 3.148,7.914 c -1.559,0 -2.03,-1 -2.03,-1.618 0,-0.986 0.75,-1.559 1.986,-2.074 1.985,-0.809 3.265,-1.559 3.265,-3.266 0,-1.53 -1.456,-2.647 -3.177,-2.647 -1.736,0 -2.913,1.014 -3.104,1.191 C -0.029,-0.397 -0.176,-0.279 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,452.75267,678.76387)",
    clipPath: "url(#clipPath339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path340",
    d: "M 0,0 C 1.485,0 2.559,-0.515 3.56,-1.368 3.677,-1.486 3.692,-1.662 3.574,-1.78 L 3.177,-2.177 C 3.06,-2.324 2.941,-2.31 2.794,-2.162 2.03,-1.5 0.985,-1.059 -0.015,-1.059 c -2.324,0 -4.104,-1.957 -4.104,-4.236 0,-2.266 1.78,-4.222 4.104,-4.222 1.28,0 2.03,0.515 2.809,1.103 0.147,0.118 0.266,0.103 0.353,0.044 l 0.442,-0.397 c 0.118,-0.088 0.088,-0.294 -0.015,-0.397 -1,-0.971 -2.265,-1.427 -3.574,-1.427 -2.942,0 -5.311,2.339 -5.311,5.281 C -5.311,-2.368 -2.942,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,474.0976,666.898)",
    clipPath: "url(#clipPath341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path342",
    d: "M 0,0 C 0,0.147 0.132,0.28 0.279,0.28 H 0.838 C 1,0.28 1.118,0.147 1.118,0 v -6.134 c 0,-1.677 1.044,-2.986 2.765,-2.986 1.736,0 2.795,1.28 2.795,2.957 V 0 c 0,0.147 0.117,0.28 0.28,0.28 H 7.517 C 7.664,0.28 7.796,0.147 7.796,0 v -6.222 c 0,-2.236 -1.589,-3.942 -3.913,-3.942 C 1.574,-10.164 0,-8.458 0,-6.222 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,485.63667,667.46707)",
    clipPath: "url(#clipPath343)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path344",
    d: "m 0,0 h -2.56 c -0.161,0 -0.279,0.132 -0.279,0.28 v 0.426 c 0,0.147 0.118,0.28 0.279,0.28 h 6.237 c 0.162,0 0.28,-0.133 0.28,-0.28 V 0.28 C 3.957,0.132 3.839,0 3.677,0 H 1.118 v -9.031 c 0,-0.148 -0.132,-0.28 -0.28,-0.28 H 0.28 C 0.132,-9.311 0,-9.179 0,-9.031 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,505.7272,668.4084)",
    clipPath: "url(#clipPath345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path346",
    d: "M 0,0 C -0.721,1.603 -1.427,3.221 -2.147,4.825 H -2.265 L -4.413,0 Z m -6.987,-3.119 4.472,9.9 c 0.044,0.088 0.118,0.162 0.25,0.162 h 0.147 c 0.132,0 0.206,-0.074 0.25,-0.162 l 4.442,-9.9 C 2.663,-3.31 2.545,-3.501 2.324,-3.501 H 1.736 c -0.132,0 -0.221,0.088 -0.25,0.162 l -1.089,2.427 h -5.222 l -1.073,-2.427 c -0.03,-0.074 -0.118,-0.162 -0.25,-0.162 h -0.589 c -0.221,0 -0.338,0.191 -0.25,0.382",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,523.776,676.1552)",
    clipPath: "url(#clipPath347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path348",
    d: "m 0,0 c 0.074,0.088 0.147,0.191 0.221,0.28 0.147,0.191 0.309,0.308 0.514,0.132 0.103,-0.088 1.177,-1.118 2.487,-1.118 1.191,0 1.97,0.75 1.97,1.618 C 5.192,1.927 4.31,2.53 2.618,3.236 1,3.942 0.029,4.604 0.029,6.281 c 0,1 0.795,2.618 3.134,2.618 1.441,0 2.515,-0.75 2.515,-0.75 C 5.766,8.105 5.943,7.928 5.766,7.649 5.708,7.561 5.648,7.458 5.59,7.37 5.457,7.164 5.31,7.105 5.075,7.237 4.972,7.296 4.045,7.914 3.148,7.914 c -1.559,0 -2.03,-1 -2.03,-1.618 0,-0.986 0.75,-1.559 1.986,-2.074 1.985,-0.809 3.265,-1.559 3.265,-3.266 0,-1.53 -1.456,-2.647 -3.177,-2.647 -1.736,0 -2.913,1.014 -3.104,1.191 C -0.029,-0.397 -0.176,-0.279 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,532.3932,678.76387)",
    clipPath: "url(#clipPath349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path350",
    d: "M 0,0 C 0.902,0 1.672,0.836 1.672,1.76 1.672,2.684 0.902,3.433 0,3.433 H -3.256 V 0 Z m -6.711,6.161 c 0,0.22 0.176,0.418 0.419,0.418 h 6.578 c 2.641,0 4.797,-2.134 4.797,-4.753 0,-2.024 -1.342,-3.652 -3.256,-4.422 l 3.014,-5.589 c 0.154,-0.286 0,-0.638 -0.374,-0.638 H 1.541 c -0.177,0 -0.309,0.11 -0.353,0.198 l -2.926,5.831 h -1.518 v -5.611 c 0,-0.22 -0.198,-0.418 -0.418,-0.418 h -2.618 c -0.243,0 -0.419,0.198 -0.419,0.418 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,165.43947,645.24107)",
    clipPath: "url(#clipPath351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path352",
    d: "M 0,0 C 0,0.22 0.176,0.418 0.418,0.418 H 9.527 C 9.77,0.418 9.946,0.22 9.946,0 v -2.398 c 0,-0.22 -0.176,-0.418 -0.419,-0.418 H 3.433 v -2.729 h 5.016 c 0.22,0 0.419,-0.198 0.419,-0.418 v -2.398 c 0,-0.242 -0.199,-0.418 -0.419,-0.418 H 3.433 v -2.971 h 6.094 c 0.243,0 0.419,-0.198 0.419,-0.418 v -2.398 c 0,-0.22 -0.176,-0.418 -0.419,-0.418 H 0.418 C 0.176,-14.984 0,-14.786 0,-14.566 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,182.01173,637.02667)",
    clipPath: "url(#clipPath353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path354",
    d: "m 0,0 c 1.848,0 3.873,-0.77 5.369,-2.068 0.198,-0.154 0.22,-0.419 0.044,-0.594 L 3.674,-4.511 C 3.499,-4.665 3.256,-4.665 3.08,-4.533 c -0.836,0.77 -1.804,1.056 -2.882,1.056 -2.399,0 -4.335,-2.024 -4.335,-4.444 0,-2.399 1.959,-4.379 4.357,-4.379 0.638,0 1.298,0.088 1.958,0.352 v 1.276 H 0.792 c -0.242,0 -0.418,0.176 -0.418,0.396 v 2.179 c 0,0.242 0.176,0.418 0.418,0.418 h 4.422 c 0.221,0 0.397,-0.198 0.397,-0.418 l 0.022,-5.919 c 0,-0.11 -0.089,-0.286 -0.176,-0.352 0,0 -2.267,-1.43 -5.457,-1.43 -4.379,0 -7.899,3.476 -7.899,7.877 0,4.4 3.52,7.921 7.899,7.921",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,214.13347,636.20493)",
    clipPath: "url(#clipPath355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path356",
    d: "M 0,0 C 0,0.22 0.198,0.418 0.418,0.418 H 3.059 C 3.279,0.418 3.477,0.22 3.477,0 v -14.566 c 0,-0.22 -0.198,-0.418 -0.418,-0.418 H 0.418 c -0.22,0 -0.418,0.198 -0.418,0.418 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,231.526,637.02667)",
    clipPath: "url(#clipPath357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path358",
    d: "M 0,0 -1.672,3.631 H -1.694 L -3.344,0 Z m -5.017,12.608 c -0.153,0.11 -0.197,0.352 -0.131,0.506 0.219,0.396 1.166,1.848 2.354,1.848 1.056,0 1.518,-1.034 2.376,-1.034 0.352,0 0.682,0.44 0.836,0.682 0.11,0.176 0.331,0.242 0.55,0.044 l 0.748,-0.572 c 0.177,-0.132 0.199,-0.374 0.022,-0.638 -0.219,-0.374 -1.034,-1.716 -2.2,-1.716 -1.144,0 -1.672,1.056 -2.42,1.056 -0.396,0 -0.682,-0.55 -0.88,-0.77 -0.133,-0.132 -0.286,-0.154 -0.485,-0.022 z m -4.026,-17.317 6.887,14.808 c 0.066,0.132 0.22,0.243 0.374,0.243 h 0.22 c 0.154,0 0.308,-0.111 0.374,-0.243 L 5.699,-4.709 C 5.831,-4.995 5.655,-5.281 5.325,-5.281 H 2.883 c -0.397,0 -0.572,0.132 -0.771,0.55 L 1.32,-2.992 h -5.985 l -0.792,-1.761 c -0.109,-0.264 -0.352,-0.528 -0.792,-0.528 h -2.42 c -0.33,0 -0.506,0.286 -0.374,0.572",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,256.4896,649.9644)",
    clipPath: "url(#clipPath359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path360",
    d: "M 0,0 C 2.42,0 4.4,1.98 4.4,4.379 4.4,6.799 2.42,8.801 0,8.801 -2.398,8.801 -4.379,6.799 -4.379,4.379 -4.379,1.98 -2.398,0 0,0 m 0,12.322 c 4.4,0 7.921,-3.543 7.921,-7.943 0,-4.401 -3.521,-7.9 -7.921,-7.9 -4.401,0 -7.899,3.499 -7.899,7.9 0,4.4 3.498,7.943 7.899,7.943",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,281.21813,652.6048)",
    clipPath: "url(#clipPath361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path362",
    d: "M 0,0 C 2.486,0 4.291,1.958 4.291,4.467 4.291,6.953 2.486,8.911 0,8.911 H -2.112 V 0 Z m -5.545,11.728 c 0,0.22 0.176,0.418 0.396,0.418 H 0.22 c 4.247,0 7.723,-3.455 7.723,-7.679 0,-4.269 -3.476,-7.723 -7.723,-7.723 h -5.369 c -0.22,0 -0.396,0.198 -0.396,0.418 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,320.93427,652.6636)",
    clipPath: "url(#clipPath363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path364",
    d: "M 0,0 C 0,0.22 0.176,0.418 0.418,0.418 H 9.527 C 9.77,0.418 9.946,0.22 9.946,0 v -2.398 c 0,-0.22 -0.176,-0.418 -0.419,-0.418 H 3.433 v -2.729 h 5.016 c 0.22,0 0.419,-0.198 0.419,-0.418 v -2.398 c 0,-0.242 -0.199,-0.418 -0.419,-0.418 H 3.433 v -2.971 h 6.094 c 0.243,0 0.419,-0.198 0.419,-0.418 v -2.398 c 0,-0.22 -0.176,-0.418 -0.419,-0.418 H 0.418 C 0.176,-14.984 0,-14.786 0,-14.566 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,340.9668,637.02667)",
    clipPath: "url(#clipPath365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path366",
    d: "m 0,0 c 2.2,0 3.829,-0.682 5.325,-2.046 0.197,-0.176 0.197,-0.44 0.022,-0.616 L 3.63,-4.445 c -0.153,-0.154 -0.396,-0.154 -0.549,0 -0.815,0.726 -1.893,1.122 -2.971,1.122 -2.486,0 -4.313,-2.068 -4.313,-4.532 0,-2.443 1.849,-4.467 4.335,-4.467 1.034,0 2.156,0.374 2.949,1.056 0.153,0.132 0.44,0.132 0.571,-0.022 l 1.717,-1.826 C 5.522,-13.268 5.5,-13.554 5.347,-13.708 3.851,-15.16 1.958,-15.842 0,-15.842 c -4.401,0 -7.943,3.498 -7.943,7.899 C -7.943,-3.542 -4.401,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,385.4668,636.17573)",
    clipPath: "url(#clipPath367)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path368",
    d: "M 0,0 C 2.42,0 4.4,1.98 4.4,4.379 4.4,6.799 2.42,8.801 0,8.801 -2.398,8.801 -4.379,6.799 -4.379,4.379 -4.379,1.98 -2.398,0 0,0 m 0,12.322 c 4.4,0 7.921,-3.543 7.921,-7.943 0,-4.401 -3.521,-7.9 -7.921,-7.9 -4.401,0 -7.899,3.499 -7.899,7.9 0,4.4 3.498,7.943 7.899,7.943",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,410.9284,652.6048)",
    clipPath: "url(#clipPath369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path370",
    d: "M 0,0 C 0,0.22 0.198,0.418 0.418,0.418 H 3.059 C 3.279,0.418 3.477,0.22 3.477,0 v -14.566 c 0,-0.22 -0.198,-0.418 -0.418,-0.418 H 0.418 c -0.22,0 -0.418,0.198 -0.418,0.418 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,430.9024,637.02667)",
    clipPath: "url(#clipPath371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path372",
    d: "m 0,0 c 0.022,0.198 0.22,0.352 0.396,0.352 h 0.352 c 0.11,0 0.308,-0.088 0.374,-0.22 l 5.105,-9.505 h 0.044 l 5.104,9.505 c 0.066,0.132 0.265,0.22 0.375,0.22 h 0.352 c 0.176,0 0.374,-0.154 0.396,-0.352 l 2.486,-14.786 c 0.044,-0.286 -0.154,-0.484 -0.418,-0.484 H 11.97 c -0.199,0 -0.396,0.176 -0.419,0.352 l -0.989,6.799 H 10.518 L 6.821,-15.248 C 6.755,-15.38 6.557,-15.49 6.447,-15.49 H 6.051 c -0.133,0 -0.308,0.11 -0.374,0.242 L 1.958,-8.119 H 1.914 L 0.946,-14.918 C 0.924,-15.094 0.748,-15.27 0.528,-15.27 h -2.596 c -0.265,0 -0.463,0.198 -0.418,0.484 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,448.47333,636.64507)",
    clipPath: "url(#clipPath373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path374",
    d: "m 0,0 c 0.858,0 1.584,0.704 1.584,1.606 0,0.88 -0.946,1.54 -1.804,1.54 H -2.002 V 0 Z m -0.286,6.007 c 0.836,0 1.54,0.704 1.54,1.584 0,0.88 -0.704,1.496 -1.54,1.496 h -1.716 v -3.08 z m -5.149,5.831 c 0,0.22 0.176,0.418 0.418,0.418 H 0.11 c 2.596,0 4.731,-1.783 4.731,-4.093 C 4.841,6.469 3.322,5.237 2.288,4.687 3.455,4.203 5.237,3.125 5.237,1.1 5.237,-1.364 3.059,-3.146 0.44,-3.146 h -5.457 c -0.242,0 -0.418,0.198 -0.418,0.417 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,485.3164,652.81013)",
    clipPath: "url(#clipPath375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path376",
    d: "M 0,0 C 0.902,0 1.672,0.836 1.672,1.76 1.672,2.684 0.902,3.433 0,3.433 H -3.256 V 0 Z m -6.711,6.161 c 0,0.22 0.176,0.418 0.419,0.418 h 6.578 c 2.641,0 4.797,-2.134 4.797,-4.753 0,-2.024 -1.342,-3.652 -3.256,-4.422 l 3.014,-5.589 c 0.154,-0.286 0,-0.638 -0.374,-0.638 H 1.541 c -0.177,0 -0.309,0.11 -0.353,0.198 l -2.926,5.831 h -1.518 v -5.611 c 0,-0.22 -0.198,-0.418 -0.418,-0.418 h -2.618 c -0.243,0 -0.419,0.198 -0.419,0.418 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,510.836,645.24107)",
    clipPath: "url(#clipPath377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path378",
    d: "M 0,0 -1.672,3.631 H -1.694 L -3.344,0 Z m -9.043,-4.709 6.887,14.808 c 0.066,0.132 0.22,0.243 0.374,0.243 h 0.22 c 0.154,0 0.308,-0.111 0.374,-0.243 L 5.699,-4.709 C 5.831,-4.995 5.655,-5.281 5.325,-5.281 H 2.883 c -0.397,0 -0.572,0.132 -0.771,0.55 L 1.32,-2.992 h -5.985 l -0.792,-1.761 c -0.109,-0.264 -0.352,-0.528 -0.792,-0.528 h -2.42 c -0.33,0 -0.506,0.286 -0.374,0.572",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,536.82547,649.9644)",
    clipPath: "url(#clipPath379)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBwAbrev);
export default __webpack_public_path__ + "static/media/logo_bw_abrev.7a0d693b529ae1fdf1c753f22d7b5fc4.svg";
export { ForwardRef as ReactComponent };